import sdkProvider from "../../../../client/sdkProvider";
import setLoyaltyIsOptedIn from "./setLoyaltyIsOptedIn";
import logger from "../../../../lib/logger";
import commonConfig from "../../../../config/common";
import { setLoyaltyTier } from ".";
import { showSuccessMessage } from "../../layout/actions";

const {
  globalKeys: { asosKey, eventBusKey },
  myAccountUrl
} = commonConfig;

const loyaltyOptIn = () => async dispatch => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");

    await loyaltySdk.setCustomerConsent("OptedIn");
    const tierId = await loyaltySdk.getCustomerTierId();

    dispatch(setLoyaltyTier(tierId));
    dispatch(setLoyaltyIsOptedIn(true));

    dispatch(
      showSuccessMessage({
        linkText: "Explore benefits",
        linkUrl: `${myAccountUrl}/asos-world`,
        message: "Sign up successful. Welcome to ASOS.WORLD!"
      })
    );

    window[asosKey][eventBusKey].emit("loyaltyStateChange", {
      optedIn: true,
      tierId
    });
  } catch (error) {
    error.message = `loyaltyOptIn failed with error: ${error.message}`;
    logger.error(error);

    throw error;
  }
};

export default loyaltyOptIn;
